export function homeImagesLoaded(state = false, action) {
  switch (action.type) {
    case 'ALL_HOME_IMAGES_LOADED':
      return action.allLoaded;
    default:
      return state;
  }
}

export function homeCounter(state = 5, action) {
  switch (action.type) {
    case 'HOME_COUNTER':
      return action.increment;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/home_counter.js